import { render, staticRenderFns } from "./FreeSubscriptionSettings.vue?vue&type=template&id=0ff60d5e&scoped=true"
import script from "./FreeSubscriptionSettings.vue?vue&type=script&lang=js"
export * from "./FreeSubscriptionSettings.vue?vue&type=script&lang=js"
import style0 from "./FreeSubscriptionSettings.vue?vue&type=style&index=0&id=0ff60d5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff60d5e",
  null
  
)

export default component.exports